<button mat-flat-button aria-label="info" type="button" (click)="onClick($event)"
        [carm-mde-popover-trigger-for]="popover" [mdePopoverTriggerOn]="(showOnHover === true) ? 'hover' : 'click'" #popoverTrigger="mdePopoverTrigger" >
  <mat-icon matSuffix [style]="'color: ' + iconColor">info</mat-icon>
</button>
<carm-mde-popover #popover="mdePopover" [mdePopoverOverlapTrigger]="false" aria-haspopup="dialog" attr.aria-label="{{'common.tooltipInfo' | translate }}">
  <mat-card appearance="outlined" class="popover-content">
    <mat-card-content>
      <ng-content></ng-content>
    </mat-card-content>
  </mat-card>
</carm-mde-popover>
